import { render, staticRenderFns } from "./TagsDropdown.vue?vue&type=template&id=27c19869&scoped=true&"
import script from "./TagsDropdown.vue?vue&type=script&lang=ts&"
export * from "./TagsDropdown.vue?vue&type=script&lang=ts&"
import style0 from "./TagsDropdown.vue?vue&type=style&index=0&id=27c19869&prod&lang=scss&scoped=true&"
import style1 from "./TagsDropdown.vue?vue&type=style&index=1&id=27c19869&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "27c19869",
  null
  
)

export default component.exports